<ion-app>
  <!-- Menú lateral (se mantiene para móvil) -->
  <ion-menu contentId="main-content" type="overlay" id="main-menu">
    <ion-content class="custom-menu">
      <ion-list>
        <ion-note style="color: white;">Especialidad</ion-note>

        @for (p of appPages; track p; let i = $index) {
          <ion-menu-toggle auto-hide="false">
            <ion-item
              routerDirection="root"
              [routerLink]="[p.url]"
              lines="none"
              detail="false"
              routerLinkActive="selected"
              class="menu-item-dark">
              <ion-icon aria-hidden="true" slot="start" [ios]="p.icon" [md]="p.icon" style="color: white;"></ion-icon>
              <ion-label style="color: #fff;">{{ p.title }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
        }

        <ion-button expand="full" color="danger" (click)="closeMenu()">Cerrar</ion-button>
      </ion-list>
    </ion-content>
  </ion-menu>

  <!-- NAVBAR SUPERIOR -->
  <ion-header class="topbar">
    <ion-toolbar class="topbar-toolbar">
      <div style="flex:1; display:flex; flex-direction:column; align-items:center; justify-content:center; position: relative; padding: 10px;">
        <!-- Logo centrado -->
        <div class="nav-center" style="display:flex; justify-content:center; align-items:center; margin-bottom: 10px;">
          <img
            src="assets/images/logovect.png"
            alt="Pro Servicios Generales"
            class="brand"
            (click)="goToInicio()"
          />
        </div>
        <!-- Menú Hamburguesa debajo del logo -->
        <div class="menu-hamburger" (click)="toggleMenu()" style="padding: 12px 18px; min-height: 70px; min-width: 250px; gap: 12px;">
          <div class="hamburger-lines" style="width: 26px; height: 22px;">
            <div class="line" style="height: 4px;"></div>
            <div class="line" style="height: 4px;"></div>
            <div class="line" style="height: 4px;"></div>
          </div>
          <div class="menu-text" style="font-size: 14px; font-weight: 700;">NUESTROS SERVICIOS</div>
        </div>
      </div>

      <!-- Acciones derechas -->

    </ion-toolbar>
    <div class="divider"></div>
  </ion-header>

  <!-- Contenido -->
  <ion-router-outlet id="main-content" style="padding-top: 180px;"></ion-router-outlet>
  <app-whatsapp-fab></app-whatsapp-fab>
</ion-app>